'use client';

import { useEffect } from 'react';
import {isMaintanceError} from "@/src/shared/utils/maintanceError";
import {GlobalErrorPage} from "@/src/components/pages";
import {MaintancePage} from "@/src/components/pages/MaintancePage";
import {logError} from "@/src/api/server-actions/analytics";

export default function Error({
       error,
   }: {
    error: Error & { digest?: string };
}) {
    useEffect(() => {
        void logError(`[error.tsx] Error [digest=${error?.digest}]`, error);
    }, [error]);

    if (isMaintanceError(error?.message)) {
        return <MaintancePage />;
    }

    return (
        <GlobalErrorPage
            title={"Скоро повернемось!"}
            description={
                "Ми працюємо над тим, щоб якнайшвидше відновити роботу сайту. Поверніться пізніше — ми вас чекатимемо!"
            }
            image={{
                src: "/images/global-error.png",
                alt: "Global error image",
                width: 200,
                height: 205,
            }}
        />
    );
}
